// extracted by mini-css-extract-plugin
module.exports = {"loader":"tb","smallLoader":"ub","loading-keyframes":"vb","pageLoader":"wb","centered":"xb","whitespacePlaceholder":"yb","buttonSpinner":"zb","fade-in":"Ab","rotate":"Bb"};